import { z } from 'zod'

export const clientInfoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    currency: z.string(),
    partner_search_enabled: z.boolean().default(false),
    external_llm_models_enabled: z.boolean().default(false),
  })
  .transform((data) => {
    const { partner_search_enabled, external_llm_models_enabled, ...rest } =
      data
    return {
      ...rest,
      partnerSearchEnabled: partner_search_enabled,
      externalLLMModelsEnabled: external_llm_models_enabled,
    }
  })
  .describe('Client Info Response')

export type ClientInfo = z.infer<typeof clientInfoSchema>
